import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, GROUPED_BY } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import { elementsInLoading, skuDetailsScores, skuDetailsScoresInLoading } from "../../@signals"


export default function useSkuDetailsKeywordsData() {
	const { showToast } = useAppToast()
	
	const data = useSignal([])
	const keywords = useSignal([])
	const aggregation = useSignal([GROUPED_BY.COUNTRY])
    const isLoadingKeywords = useSignal(false)

	const optionSelected = useSignal(GROUPED_BY.COUNTRY)

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			data.value = []
            isLoadingKeywords.value = true
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/keywords`, { ...commonFiltersValue.value, groupedBy: aggregation.value }).then(res => {
				data.value = res.data
				keywords.value = res.keywords
                skuDetailsScores.value["Keywords"] = res.keywordScore
			}).catch(() => showToast.error()
            ).finally(() => {
				isLoadingKeywords.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	const handleChangeOption = (e) => {
		optionSelected.value = e.target.value

		if (optionSelected.value === GROUPED_BY.COUNTRY)
			aggregation.value = [GROUPED_BY.COUNTRY]

		if (optionSelected.value === GROUPED_BY.RETAILER)
			aggregation.value = [GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]

		data.value = []
		isLoadingKeywords.value = true
		postSubmit(`${BACKEND_APIS.SKU_DETAILS}/keywords`, { ...commonFiltersValue.value, groupedBy: aggregation.value }).then(res => {
			data.value = res.data
			keywords.value = res.keywords
		}).catch(() => showToast.error()
		).finally(() => {
			isLoadingKeywords.value = false
		})
	}

    useEffect(() => {
		if (isLoadingKeywords.value) {
			elementsInLoading.value = [...elementsInLoading.value, 'productPageKpis']
			skuDetailsScoresInLoading.value = [...skuDetailsScoresInLoading.value, "Keywords"]
		} else {
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'productPageKpis')
			skuDetailsScoresInLoading.value = skuDetailsScoresInLoading.value.filter(item => item !== "Keywords")
		}
	}, [isLoadingKeywords.value])

	return {
		data: data.value,
		keywords: keywords.value,
		aggregation: aggregation.value,
		optionSelected: optionSelected.value,
		isLoadingKeywords: isLoadingKeywords.value,
		handleChangeOption
	}
}